module.exports = __webpack_public_path__ + "static/media/leaderboard-logo.646a4d75.svg";